import { Users, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

function formatEur(n) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 0, signDisplay: 'auto',
  }).format(Number(n ?? 0));
}

/**
 * ApplyGroupOverrideResult — shown after aplicar_override_grupo returns a plan.
 * Note: this tool returns a PLAN, not an executed mutation. The card is
 * informational (amber) and lets the user see who is affected and net impact.
 */
export default function ApplyGroupOverrideResult({ result }) {
  if (!result) return null;
  const sample = result.sample_empleados ?? [];
  const total = result.total_afectados ?? 0;
  const impacto = result.impacto_neto_total ?? 0;

  return (
    <div className="rounded-xl border border-warning/30 bg-warning/10 p-3 my-1 max-w-sm space-y-2">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Users className="w-4 h-4 text-warning shrink-0" />
          <div className="min-w-0">
            <p className="text-xs font-semibold text-foreground">
              Plan de override · {result.periodo}
            </p>
            <p className="text-[10px] text-muted-foreground">
              {total} empleado{total !== 1 ? 's' : ''} afectado{total !== 1 ? 's' : ''}
              {impacto !== 0 && ` · neto ${impacto > 0 ? '+' : ''}${formatEur(impacto)}`}
            </p>
          </div>
        </div>
        <Link to={`/nominas?periodo=${result.periodo}`}>
          <Button size="sm" variant="outline"
            className="h-7 text-[11px] shrink-0 gap-1 border-warning/30 text-warning hover:bg-warning/10">
            Ver
            <ExternalLink className="w-3 h-3" />
          </Button>
        </Link>
      </div>

      {sample.length > 0 && (
        <div className="text-[10px] text-muted-foreground space-y-0.5 border-t border-warning/30 pt-2">
          {sample.map((emp, i) => (
            <p key={i} className="truncate flex justify-between">
              <span>{emp.nombre}{emp.departamento ? ` · ${emp.departamento}` : ''}</span>
              {emp.impacto_neto != null && (
                <span className="tabular-nums">{emp.impacto_neto > 0 ? '+' : ''}{formatEur(emp.impacto_neto)}</span>
              )}
            </p>
          ))}
          {total > sample.length && (
            <p className="text-[10px] text-muted-foreground">…y {total - sample.length} más</p>
          )}
        </div>
      )}
    </div>
  );
}
